import _classCallCheck from "/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/postcard-editor/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { LineSegments2 } from './LineSegments2.js';
import { LineGeometry } from './LineGeometry.js';
import { LineMaterial } from './LineMaterial.js';

var Line2 = /*#__PURE__*/function (_LineSegments) {
  _inherits(Line2, _LineSegments);

  function Line2() {
    var _this;

    var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new LineGeometry();
    var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new LineMaterial({
      color: Math.random() * 0xffffff
    });

    _classCallCheck(this, Line2);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Line2).call(this, geometry, material));
    _this.isLine2 = true;
    _this.type = 'Line2';
    return _this;
  }

  return Line2;
}(LineSegments2);

export { Line2 };